// API URL: /api/courseapi/getcoursevariants/{pageNumber}/{pageId}/{language}
import Basket from '../modules/basket';

if ($('.courses-calendar-page').length > 0) {
    var getUrl = window.location,
        baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[0],
        pageId = $('.courses-calendar-page').attr('data-pagetypeid'),
        pageNumber = 1,
        language = $('html').attr('lang'),
        calendarUrl = baseUrl + 'api/courseapi/getcoursevariants/'+ pageNumber + '/' + pageId + '/' + language,
        breakpoints = {
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1260
        },
        viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        maxVisible = 10;

    if (viewportWidth < breakpoints.md) {
        maxVisible = 5;
    }
    if (viewportWidth < breakpoints.sm) {
        maxVisible = 3;
    }

    $.fn.toggleCalendarAccordion = function() {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 
        if (viewportWidth > breakpoints.lg) {
            $('#calendar-accordion .accordion-header').attr('data-toggle', '');
        } else {
            $('#calendar-accordion .accordion-item').each( function() {
                $(this).find('.accordion-header').attr('data-toggle', 'collapse');
            });
        }
    };


    // pagination
    $.fn.pagination = function (pages) {
        if (pages > 1 && pages < maxVisible) {
            $('#pagination').bootpag({
                total: pages,
                maxVisible: pages,
                wrapClass: 'pagination justify-content-center',
                next: '',
                prev: '',
                nextClass: 'hidden',
                prevClass: 'hidden',
                page: 1,
                firstLastUse: false,
            });
        } else if (pages > 1) {
            $('#pagination').bootpag({
                total: pages,
                maxVisible: maxVisible,
                wrapClass: 'pagination justify-content-center',
                next: '. . .',
                prev: '. . .',
                page: 1,
                firstLastUse: true,
                first: '',
                last: ''
            });
        } else {
            $('#pagination ul').remove();
        }
    };



    // Render a retry prompt instead of leaving the accordion empty. The endpoint answers
    // 503 when the course list genuinely could not be loaded (e.g. Optimizely Graph is
    // unavailable) — showing an empty calendar there would read as "no courses scheduled".
    $.fn.renderCalendarError = function(retryFn) {
        var $page = $('.courses-calendar-page'),
            message = $page.attr('data-error-message'),
            retryLabel = $page.attr('data-error-retry-label');

        $('#calendar-accordion').html(
            $('<div class="course-calendar-error text-center py-4"></div>')
                .append($('<p></p>').text(message))
                .append($('<button type="button" class="btn btn-primary course-calendar-retry"></button>').text(retryLabel))
        );
        $('#pagination ul').remove();
        $('#calendar-accordion').one('click', '.course-calendar-retry', retryFn);
    };

    // Update list on pagination click
    $.fn.paginationClick = function() {
        $('#pagination').unbind('page').bootpag().on('page', function(event, pageNumber){
            calendarUrl = baseUrl + 'api/courseapi/getcoursevariants/'+ pageNumber + '/' + pageId + '/' + language;

            $.get(calendarUrl, function(data) {
                $('#calendar-accordion').html(data.Html);
                new Basket();
            }).fail(function() {
                $.fn.renderCalendarError(function() {
                    $.fn.loadCalendarPage(pageNumber);
                });
            });
            $(window).scrollTop(0);
        });
    };

    // initiate pagination listener
    $.fn.paginationClick();


    // Load a page of the calendar, wiring up pagination and the error state.
    $.fn.loadCalendarPage = function(requestedPage) {
        var url = baseUrl + 'api/courseapi/getcoursevariants/'+ requestedPage + '/' + pageId + '/' + language;

        $.get(url, function(data) {
            $('#calendar-accordion').html(data.Html);
            $.fn.pagination(data.Pages);
            $.fn.toggleCalendarAccordion();
            $.fn.paginationClick();
            new Basket();
        }).fail(function() {
            $.fn.renderCalendarError(function() {
                $.fn.loadCalendarPage(requestedPage);
            });
        });
    };

    // get initial list on page 1
    $.fn.loadCalendarPage(pageNumber);

    // toggle accordion on device rotation
    $(window).resize(function() {
        $.fn.toggleCalendarAccordion();
    });
};


